import BasketIcon from '@material-ui/icons/LocalMallRounded';
import BasketList from './BasketList';
import BasketCreate from './BasketCreate';
const BasketModule = {
    list: BasketList,
    icon: BasketIcon,
    create: BasketCreate,
}; export default BasketModule;